import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';

export function useIsCurrentRoute() {
    const { pathname } = useLocation();

    return useCallback(
        // TODO: do we need to check for 'edit' or 'delete' here?
        (id: string | number) => pathname.split('/').some((p) => p === String(id)),
        [pathname],
    );
}
